var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0C4.35789 0 2.84211 0.694737 1.76842 1.76842C0.663158 2.84211 0 4.35789 0 6C0 7.64211 0.694737 9.15789 1.76842 10.2316C2.84211 11.3368 4.35789 12 6 12C7.64211 12 9.1579 11.3053 10.2316 10.2316C11.3053 9.15789 12 7.64211 12 6C12 5.8147 11.9912 5.63101 11.9739 5.44938C11.8669 6.36895 11.4377 7.20438 10.8211 7.82105C10.1053 8.53684 9.09474 9 8 9C6.90526 9 5.89474 8.55789 5.17895 7.82105C4.46316 7.10526 4 6.09474 4 5C4 3.90526 4.44211 2.89474 5.17895 2.17895C5.89474 1.46316 6.90526 1 8 1C8.7164 1 9.39674 1.18933 9.98201 1.52669C8.92922 0.567176 7.51863 0 6 0Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/Moon.b9ea8abefce90a8fa66ee35e78e934a8.svg";
export { ForwardRef as ReactComponent };